// skills/woodworking/index.js
// Woodworking skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import {
    renderWoodworkingUI,
    updateWoodworkingUI,
    initWoodworkingUI,
    toggleMakingShafts,
    toggleMakingArrows,
    toggleMakingBow,
    toggleMakingStaff,
    upgradeTool,
    switchTab
} from './woodworkingUI.js';

/**
 * Woodworking skill configuration
 */
const woodworkingConfig = {
    id: 'woodworking',
    name: 'Woodworking',
    icon: '🏹',
    iconImage: 'assets/icons/skill_icons/woodworking.png',
    description: 'Craft arrows, bows, and ranged ammunition',

    tabs: [
        { id: 'shafts', name: 'Shafts', default: true },
        { id: 'arrows', name: 'Arrows' },
        { id: 'bows', name: 'Bows' },
    ],

    render(params = {}) {
        renderWoodworkingUI(params);
    },

    update() {
        updateWoodworkingUI();
    },

    init() {
        initWoodworkingUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('woodworking', woodworkingConfig);

if (typeof window !== 'undefined') {
    window.woodworkingUI = {
        toggleMakingShafts,
        toggleMakingArrows,
        toggleMakingBow,
        toggleMakingStaff,
        upgradeTool,
        switchTab
    };
}

export default woodworkingConfig;
